/**
 * El estado de cada seccion esencial de Maderinco (MADERINCO-ARBOLES-SECCIONES-T1; Atenea #30340/#30341, Ares #30346).
 *
 * Estados del JSON de Atenea (section_states): pendiente / en_curso / resuelta / no_aplica / por_revisar.
 * Contrato (consumer_contract):
 *   - resuelta requiere las respuestas obligadas confirmadas, o no_aplica con motivo;
 *   - lo tecnico pendiente es por_revisar (no cuenta como resuelta);
 *   - la siguiente busca pendiente / en_curso; por_revisar queda en el resumen, sin bucle;
 *   - al terminar no se declara el presupuesto completo.
 * Cubierta se resuelve con sus 3 preguntas; las demas con su arbol (arbolEsencial.estadoDelArbol, en deArboles). Sin
 * respuestas en el arbol, una esencial con partidas puestas queda en_curso.
 *
 * @module application/presupuestos/estadoEsenciales
 */
import { ESENCIALES } from './ordenDeSecciones.js';
import { cubiertaRespondida, puestoEsencial } from './siguienteSeccion.js';

export const ETIQUETA_ESTADO = { pendiente: 'pendiente', en_curso: 'en curso', resuelta: 'resuelta', no_aplica: 'no aplica', por_revisar: 'por revisar' };

/**
 * @param {{ secciones?: Array<{items?:any[], plantillaClave?:string}> }} armador el presupuesto que se arma
 * @param {(s:any) => any} seccionDePlantilla de una seccion del armador a su seccion de la plantilla (con items y fuenteId)
 * @param {{tipo?:string, q2?:string, q3?:string, revisar?:boolean}} cubierta estado de las preguntas de Cubierta
 * @param {Map<string,string>} noAplica id de esencial -> motivo (sin motivo no cuenta)
 * @returns {Array<{id:string, nombre:string, estado:string, motivo?:string}>}
 */
export function estadosDeEsenciales({ armador, seccionDePlantilla, cubierta = {}, noAplica = new Map(), esenciales = ESENCIALES, deArboles = {} }) {
  const conPartidas = new Set();
  for (const s of armador?.secciones || []) {
    if (!(s.items || []).length) continue;
    const p = puestoEsencial(seccionDePlantilla(s), esenciales);
    if (Number.isFinite(p)) conPartidas.add(esenciales[p].id);
  }
  return esenciales.map((e, i) => {
    const motivo = String(noAplica.get(e.id) || '').trim();
    if (motivo) return { id: e.id, nombre: e.nombre, estado: 'no_aplica', motivo };
    if (i === 0) {
      if (cubierta.revisar) return { id: e.id, nombre: e.nombre, estado: 'por_revisar' };
      if (cubiertaRespondida(cubierta)) return { id: e.id, nombre: e.nombre, estado: 'resuelta' };
      if (cubierta.tipo || conPartidas.has(e.id)) return { id: e.id, nombre: e.nombre, estado: 'en_curso' };
      return { id: e.id, nombre: e.nombre, estado: 'pendiente' };
    }
    // Parte 2: si el arbol de la esencial ya tiene estado (resuelta / por_revisar / en_curso), manda ese.
    const arbol = deArboles[e.id];
    if (arbol && arbol !== 'pendiente') return { id: e.id, nombre: e.nombre, estado: arbol };
    return { id: e.id, nombre: e.nombre, estado: conPartidas.has(e.id) ? 'en_curso' : 'pendiente' };
  });
}
